import { render, staticRenderFns } from "./StoredTripsGroupCard.vue?vue&type=template&id=199a514f"
import script from "./StoredTripsGroupCard.vue?vue&type=script&lang=ts"
export * from "./StoredTripsGroupCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports